import { cloneDeep } from "lodash";
import { faqActions as actions } from "../actions";
import { initialState } from "../initialState";
import { createReducer, methodSwitcher } from "./utilities";

const { faq } = initialState;

const clearCurrent = (state) => ({ ...state, current: {} });

const setFaqList = (state, { data }) => {
  const newState = cloneDeep(state);
  newState.list = data;
  return newState;
};

const setCurrentFaq = (state, { data }) => {
  const newState = cloneDeep(state);
  newState.current = data;
  return newState;
};

const actionFaq = (state, { data, id, method }) => {
  const newState = cloneDeep(state);
  methodSwitcher(newState, data, id, method);
  return newState;
};

const clearCategoryCurrent = (state) => ({ ...state, categories: [] });

const setFaqCategoryList = (state, { data }) => {
  const newState = cloneDeep(state);
  newState.categories = data;
  return newState;
};

const actionFaqCategory = (state, { data, id, method }) => {
  const newState = cloneDeep({ list: state.categories });
  methodSwitcher(newState, data, id, method);
  return { ...state, categories: newState.list };
};

const clearSubcategoryCurrent = (state) => ({ ...state, subcategories: {} });

const setFaqSubcategoryList = (state, { data }) => {
  const newState = cloneDeep(state);
  newState.subcategories = data;
  return newState;
};

const actionFaqSubcategory = (state, { data, id, method }) => {
  const newState = cloneDeep({ list: state.subcategories });
  methodSwitcher(newState, data, id, method);
  return { ...state, subcategories: newState.list };
};

export const faqReducer = createReducer(faq, {
  [actions.CLEAR_CURRENT]: clearCurrent,
  [actions.LIST]: setFaqList,
  [actions.CURRENT]: setCurrentFaq,
  [actions.CUD]: actionFaq,
  [actions.CATEGORY_CLEAR_CURRENT]: clearCategoryCurrent,
  [actions.CATEGORY_LIST]: setFaqCategoryList,
  [actions.CATEGORY_CUD]: actionFaqCategory,
  [actions.SUBCATEGORY_CLEAR_CURRENT]: clearSubcategoryCurrent,
  [actions.SUBCATEGORY_LIST]: setFaqSubcategoryList,
  [actions.SUBCATEGORY_CUD]: actionFaqSubcategory
});
